import React from 'react';
import { formatLocalDate } from '../../utils/localDateTime';
import { getMapCoordinates } from '../../utils/mapCoordinates';
import type { ThreatGroupIncidentMonth } from '../../utils/threatGroupTimeline';
import { httpSource } from '../../../functions/src/common/threatGroupTelemetry';

const monthFormatter = new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' });

const ThreatGroupIncidentTooltip: React.FC<{ month?: ThreatGroupIncidentMonth }> = ({ month }) => {
    if (!month)
        return null;

    return (
        <div role="tooltip" tabIndex={0} onMouseMove={event => event.stopPropagation()} onTouchMove={event => event.stopPropagation()}
            className="max-h-[260px] w-[300px] max-w-[calc(100vw-3rem)] overflow-y-auto rounded-lg border border-slate-200 bg-white p-3 text-xs text-slate-800 shadow-lg dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100">
            <p className="font-semibold">{monthFormatter.format(new Date(`${month.month}-01T12:00:00`))}</p>
            <p className="mt-1">{month.count} listed {month.count === 1 ? 'incident' : 'incidents'}</p>
            <p className="mt-1">Local: {month.localCount}; wider theater: {month.theaterCount}; unclassified: {month.unclassifiedCount}.</p>
            {month.incidents.length > 0 ? (
                <ul className="mt-3 space-y-3">
                    {month.incidents.map((incident, index) => {
                        const coordinates = getMapCoordinates(incident);
                        const location = (typeof incident.location === 'string' ? incident.location.trim() : '') || (coordinates
                            ? `${coordinates.lat.toFixed(4)}, ${coordinates.lng.toFixed(4)}` : 'Not recorded');
                        return (
                            <li key={index} className="border-t border-slate-200 pt-2 dark:border-slate-700">
                                <p className="font-semibold">{formatLocalDate(incident.date.trim().slice(0, 10), incident.date)}{incident.type && ` · ${incident.type}`}</p>
                                <p className="mt-1">Location: {location}</p>
                                {incident.country && <p className="mt-1">Country: {incident.country}</p>}
                                <p className="mt-1 whitespace-pre-wrap break-words">{incident.description || 'Description not recorded.'}</p>
                                {httpSource(incident.sourceUrl) && <a href={incident.sourceUrl} target="_blank" rel="noopener noreferrer" className="mt-1 inline-block underline">Incident source</a>}
                            </li>
                        );
                    })}
                </ul>
            ) : <p className="mt-3">No dated incidents for this month are listed in this dossier.</p>}
        </div>
    );
};

export default ThreatGroupIncidentTooltip;
